import { render, staticRenderFns } from "./TrademarkSearchDatabase.vue?vue&type=template&id=00023ec9&"
import script from "./TrademarkSearchDatabase.vue?vue&type=script&lang=js&"
export * from "./TrademarkSearchDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports